var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"viewer_actions"}),_c('div',{staticClass:"pdf_content"},[_c('iframe',{attrs:{"src":_vm.pdf_url,"frameborder":"0"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }